import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import PlayerCorner from '../components/PlayerCorner.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/playercorner',
    name: 'PlayerCorner',
    component: PlayerCorner,
    meta:{
      private:true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
